// eslint-disable-next-line complexity
export function getElementDimensions(element = null) {
  if (!element) return;

  const elementDom = document.querySelector(element);
  const rect = elementDom.getBoundingClientRect();
  const computedStyle = window.getComputedStyle(elementDom);

  const isSticky = computedStyle.position === 'sticky';
  const stickyTopValue = isSticky ? parseFloat(computedStyle.top) || 0 : 0;
  const isCurrentlyStuck = isSticky && rect.top <= stickyTopValue;

  const distanceFromTop = isCurrentlyStuck ? 0 : rect.top;

  return {
    ...rect,
    height: elementDom.clientHeight || rect.height,
    width: elementDom.clientWidth || rect.width,
    top: elementDom.offsetTop,
    distanceFromTop,
  };
}
